import { Div } from "../../../base/components/native/div"
import { SVG } from "../../../base/components/native/svg"
import * as styles from "./message.style"

export const Message = () => {
    const base = Div()
    base.cssClass(styles.baseStyle)
    
    const icon = SVG(`<circle cx="32" cy="32" r="30" fill="#4bd37b"/><path fill="#ffffff" d="M46 14L25 35.6l-7-7.2l-7 7.2L25 50l28-28.8z"/>`, '0 0 64 64')
    icon.style({ width: '24px', height: '24px' })

    const message = Div('File uploaded successfully!')

    base.append(icon)
    base.append(message)

    return base
}
